import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.auth.user;
export const userDataSelector = (state: RootState) => getState(state).data;
export const userEmailSelector = (state: RootState) => userDataSelector(state)?.email;
